module.exports = __webpack_public_path__ + "img/Panda Samurai Esport Logo.jpg";